/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { DateIcon, MultiSelectIcon, PersonIcon, SelectIcon } from '@sketchnote/icons';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

export const PropertyLabels = {
  multiSelect: <MultiSelectIcon />,
  select: <SelectIcon />,
  date: <DateIcon />,
  person: <PersonIcon />,
};

export const PropertyOptions = [
  {
    label: 'High',
    value: 'high',
    type: 'multi-select',
  },
  {
    label: 'Medium',
    value: 'medium',
    type: 'select',
  },
  {
    label: 'Low',
    value: 'low',
    type: 'date',
  },
];

export const getPropertyLabel = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

type OptionType = OptionTypeBase & {
  label: string;
  value: string;
  // type: keyof typeof PropertyLabels;
};
type GroupType = GroupTypeBase<OptionType>;

export const PropertySelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  control: (styles) => ({
    ...styles,
    backgroundColor: '#F6F7F9',
    padding: '0.2rem 1rem 0.2rem 0px',
    borderRadius: '6px',
    borderColor: '#E2E4E9',
    fontWeight: 400,
    fontSize: '1.6rem',
    color: '#131720',
    width: '100%',
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: '6px',
    width: '100%',
    marginTop: '0.7rem',
    background: '#fff',
    boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)',
    padding: '0.6rem 0.6rem',
  }),
  menuList: (styles) => ({
    ...styles,
    padding: '0px',
  }),
  group: (styles) => ({
    ...styles,
    padding: '0 0 0.5rem 0',
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontWeight: 400,
    color: '#878A92',
    fontSize: '14px',
    padding: '0.6rem 0.8rem',
    textTransform: 'none',
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? '#F6F7F9'
        : isSelected
        ? '#EEF1FC'
        : isFocused
        ? '#F6F7F9'
        : 'inherit',
      padding: '0.6rem 0.6rem 0.6rem 0.4rem',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '0.5rem',
      color: isDisabled ? '#ccc' : '#131720',
      cursor: isDisabled ? 'not-allowed' : 'default',
      borderRadius: '6px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#EEF1FC',
        padding: '1.3rem 1.5rem 1.3rem 1rem',
      },
    };
  },
  multiValue: (styles) => ({
    ...styles,
    margin: '0',
    backgroundColor: 'inherit',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    ':hover': {
      background: '#EEF1FC',
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const PropertySelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    {props.data.icon}
    <span className="ml-8">{props.data.label}</span>
  </div>
);

export const PropertySelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      {props.data.icon}
      <span className="ml-8">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);
